"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AccountSessionMixins } from "@/service/account-session";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchRules = class extends Mixins(AccountSessionMixins) {
  get show() {
    if (this.$session.type === "account") {
      if (this.$session.marks.is("CLASSIC_ROLE_STYLE")) {
        return false;
      } else {
        return true;
      }
    } else {
      if (this.$session.marks.is("CLASSIC_ROLE_STYLE")) {
        return false;
      } else {
        return true;
      }
    }
  }
  batchEditRules() {
    return __async(this, null, function* () {
      this.$emit("editrules");
    });
  }
};
__decorateClass([
  PropSync("selectItem")
], BatchRules.prototype, "_controller", 2);
BatchRules = __decorateClass([
  Component
], BatchRules);
export {
  BatchRules as default
};
